<template>
  <span class="icon-reward-total-redeem-point">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.24487 7.34647L11.1024 1.55738C11.4693 0.814208 12.529 0.814208 12.8958 1.55738L15.7534 7.34647L22.1438 8.28051C22.9637 8.40036 23.2905 9.4082 22.6969 9.98636L18.0737 14.4894L19.1647 20.851C19.3049 21.6679 18.4473 22.2909 17.7137 21.9051L11.9991 18.8998L6.28459 21.9051C5.55096 22.2909 4.69341 21.6679 4.83353 20.851L5.92461 14.4894L1.3014 9.98636C0.707809 9.4082 1.03459 8.40036 1.85451 8.28051L8.24487 7.34647ZM9.80584 8.70262C9.6603 8.99747 9.37912 9.20193 9.05376 9.24949L4.14755 9.9666L7.69687 13.4236C7.93274 13.6534 8.0404 13.9845 7.98474 14.309L7.14732 19.1917L11.5337 16.8849C11.8251 16.7317 12.1732 16.7317 12.4646 16.8849L16.851 19.1917L16.0135 14.309C15.9579 13.9845 16.0655 13.6534 16.3014 13.4236L19.8507 9.9666L14.9445 9.24949C14.6192 9.20193 14.338 8.99747 14.1924 8.70262L11.9991 4.25925L9.80584 8.70262Z" :fill="color"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this.$store.state.color['coolGrey-500'] } }
  }
}
</script>
